import React from "react"

const NewlineText = ({ text }) => text.split("\n")
    .filter(e => e.trim().length > 0)
    .map((str, idx) => <p key={idx}>{str}</p>)

export default NewlineText
